import React from 'react';
import { Panel, Div, PanelHeader, Button, List, FixedLayout, Tabs, TabsItem, Cell, Avatar, ScreenSpinner, Footer, Link, Search, Group } from '@vkontakte/vkui';
import '@vkontakte/vkui/dist/vkui.css';
import Icon16Verified from '@vkontakte/icons/dist/16/verified';

class Home extends React.Component {

	constructor (props) {
		super(props);
		this.state = {
			search: ''
		}
		this.onChange = this.onChange.bind(this);
	}

	onChange (search) {
		this.setState({ search }); 
	}

	get items () {
		var search = this.state.search.toLowerCase();

		if (this.props.activeTab === 'groups') {
			return this.props.fetchedGroupsApi.filter(
				({name, is_closed, deactivated, type}) => {
					if ( (name.toLowerCase().indexOf(search) > -1) && (is_closed === 0) && (!deactivated) && (type !== 'event') ) {
						return true;
					} else {
						return false;
					}
				}
			);
		} else {
			return this.props.fetchedGroupsApi.filter(
				({name, is_closed, deactivated, type, is_admin}) => {
					if ( (name.toLowerCase().indexOf(search) > -1) && (is_closed === 0) && (!deactivated) && (type !== 'event') && (is_admin === 1) ) {
						return true;
					} else {
						return false;
					}
				}
			);
		}
	}

	render() {
		//alert(JSON.stringify(this.props.fetchedGroupsApi));
		if (this.props.fetchedGroupsApi.length) {
			return (
				<Panel id={this.props.id}>
					<PanelHeader noShadow>SMM Анализ</PanelHeader>
					<Search value={this.state.search} onChange={this.onChange}/>

						<List title="Выберите группу для проверки">
							{ //если ничего не найдено.
								(this.props.activeTab === 'groups') ?
									(this.items.length < 1) ?
										<Cell>
											<center>Ничего не найдено</center>
										</Cell>
									: null
								: 
								(this.props.scope.indexOf('groups') + 1) ?
									(this.items.length < 1) ?
										<Cell>
											<center>Ничего не найдено</center>
										</Cell>
									: null
								: null
							}
						
						{
							(this.props.activeTab === 'groups') ? 

								this.items.map(item => {
									return ((item.is_closed === 0) && (!item.deactivated) && (item.type !== 'event')) ?
											<Cell key={item.id} size="m" before={<Avatar src={item.photo_200}/>} description={item.activity}
													onClick={
															() => { 
																this.props.targetData(item) 
																this.props.SetActivePanel('moreGid')
															}
													}>
												{item.name} {(item.verified === 1) ? <Icon16Verified className="VerifiedIcon" /> : null}
											</Cell>
									: null
								})
							 : 
							 	(this.props.scope.indexOf('groups') + 1) ?
									this.items.map(item => {
										return ((item.is_closed === 0) && (item.type !== 'event') && (!item.deactivated) && (item.is_admin === 1)) ?
												<Cell key={item.id} size="m" before={<Avatar src={item.photo_200}/>} description={item.activity}
														onClick={
																() => { 
																	this.props.targetData(item) 
																	this.props.SetActivePanel('moreGid')
																}
														}>
													{item.name} {(item.verified === 1) ? <Icon16Verified className="VerifiedIcon" /> : null}
												</Cell>
										: null
									})
								:
								<Group>
									<Div className="white_color_text">
										Сейчас эта сортировка недоступна, так как Вы не дали доступ приложению к сообществам, которыми управляете.
									</Div>
									<Div className="mt0">
										Вы можете нажать на кнопку и дать необходимый доступ прямо сейчас.
									</Div>
									<Div className="mt0">
										<Button size="xl" onClick={this.props.GetToken}>Дать доступ</Button>
									</Div>
								</Group>
						}
						</List>
					<Footer style={{paddingBottom: 45}}>
						<Link target="_blank" className="CustomLink" href="https://vk.com/club39599132">Группа</Link>
						<Link target="_blank" className="CustomLink" href="https://vk.com/@kupiapp-servis-smm-analiz">О приложении</Link>
					</Footer>

					<FixedLayout vertical="bottom">
						<Tabs>
							<TabsItem 
								onClick={() => this.props.SetActiveTab('groups')}
								selected={this.props.activeTab === 'groups'}
								>Все сообщества
							</TabsItem>
							<TabsItem
								onClick={() => this.props.SetActiveTab('admin')}
								selected={this.props.activeTab === 'admin'}
							>Управление
							</TabsItem>
						</Tabs>
					</FixedLayout>
				</Panel>
			)			
		} else {
			return (
				<ScreenSpinner />
			)
		}
	}

}

export default Home;


// WEBPACK FOOTER //
// ./src/panels/Home.js